module.exports = __webpack_public_path__ + "static/media/crocodile(9).5c52584e.PNG";